module.exports = require("babel-runtime/core-js/object/assign");